import script from "./FormInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInfo.vue?vue&type=script&setup=true&lang=js"

import "./FormInfo.vue?vue&type=style&index=0&id=60328d0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60328d0e"]])

export default __exports__